module.exports = __webpack_public_path__ + "src/images/measurements/waistLengthBack.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/waistLengthBack.jpg
// module id = 1162
// module chunks = 0